import api from 'app/api';
import getAll from './get-product-categories-with-join';
import addProdcutCategory from './add-product-category';
import editProductCategory from './edit-product-category';
import getProductCategoryWithDocument from './get-product-category-with-document';

export const productCategoriesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getProductCategories: getAll(builder),
        addProductCategory: addProdcutCategory(builder),
        editProductCategory: editProductCategory(builder),
        getProductCategoryWithDocument: getProductCategoryWithDocument(builder),
    }),
});

export const {
    useGetProductCategoriesQuery,
    useAddProductCategoryMutation,
    useEditProductCategoryMutation,
    useGetProductCategoryWithDocumentQuery,
} = productCategoriesApi;
